import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {ReportChatFilter} from 'yougile-model'
import {Remove, Separator} from '@components/statistics/stats-reports/common'
import {
  DropdownList,
  Option
} from '@components/common/dropdown-list/dropdown-list'
import {NumberInput} from '@components/common/text-input/text-input'

interface OuterProps {
  filter: ReportChatFilter
}

interface Props extends OuterProps {
  update: (filters: ReportChatFilter) => void
}

export const ChatFilter = (props: Props) => {
  const {filter = {type: 'no-messages'}, update} = props
  useEffect(() => {
    if (!props.filter) {
      props.update({type: 'no-messages'})
    }
  }, [props.filter])

  const options = getOpts()
  const selectValue = getSelectedValue(props)

  return (
    <div className="flex justify-between">
      <div className="flex">
        <DropdownList
          className="w-176"
          initialOpen={!props.filter}
          onChange={type =>
            update({
              ...filter,
              type,
              count: type !== 'no-messages' ? 0 : undefined
            })
          }
          value={selectValue.type}
          options={options}
        />
        {selectValue.type !== 'no-messages' && (
          <>
            <Separator />
            <NumberInput
              className="w-64"
              value={filter.count}
              onChange={newValue =>
                update({
                  ...filter,
                  count: newValue
                })
              }
            />
          </>
        )}
      </div>
      <Remove update={update} />
    </div>
  )
}

const getSelectedValue = (props: OuterProps): ReportChatFilter => {
  const {filter} = props

  return filter ?? {type: 'no-messages'}
}

const getOpts = () => {
  const options: Option<ReportChatFilter['type']>[] = [
    {
      value: 'no-messages',
      label: Lang.msg.component.chatFilter.withoutMessages
    },
    {value: 'more', label: Lang.msg.component.chatFilter.more},
    {value: 'less', label: Lang.msg.component.chatFilter.less}
  ]
  return options
}

export const ChatFilterValue = (props: OuterProps) => {
  const opts = getOpts()
  const selectValue = getSelectedValue(props)
  const value = opts.find(opt => opt.value === selectValue.type)
  return (
    <>
      {value?.label ?? ''}
      {selectValue.type !== 'no-messages' && (
        <span className="ml-2"> {selectValue.count}</span>
      )}
    </>
  )
}
